<template>
  <transition name="slide-top">
    <div class="flyout badge-catcher" v-if="isAppear && currentItem.type === 'badge'" @click="skipBadge">
      <div class="image-wrapper">
        <img class="image-fit" :src="currentItem.image">
      </div>
      <div class="ml-2">
        <b>Badge didapatkan!</b>
        <p>{{currentItem.name}}</p>
        <small>{{currentItem.description}}</small><br>
        <small><i class="fas fa-coins"></i> <b>+{{currentItem.reward}}</b></small>
      </div>
    </div>
    <div class="flyout badge-catcher" v-else-if="isAppear && currentItem.type === 'miniQuest'" @click="skipBadge">
      <div>
        <b>Mini-Quest Selesai!</b><br>
        <small>{{currentItem.description}}</small><br>
        <small><i class="fas fa-coins"></i> <b>+{{currentItem.reward}}</b></small>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'badgeCatcher',
    data() {
      return {
        isAppear: false,
        badgeQueue: [],
        currentItem: {
          id: -1,
          name: 'Test',
          description: 'No description provided',
          image: require('@/assets/badges/1000.png')
        },
        timeoutObj: null,
      }
    },
    created() {
      this.$store.watch((_, getters) => getters['userStore/getScores'], val => {
        if (val === 1000 && !this.badgesData[8].acquired) {
          this.acquireBadge(8)
        }
      })
    },
    destroyed() {
      if (this.intervalObj) clearInterval(this.intervalObj)
    },
    watch: {
      'userDataStore.level'(val) {
        if (val === 2 && !this.badgesData[0].acquired) {
          this.acquireBadge(0)
        }
        if (val === 5 && !this.badgesData[1].acquired) {
          this.acquireBadge(1)
        }
        if (val === 10 && !this.badgesData[2].acquired) {
          this.acquireBadge(2)
        }
      },
      'userDataStore.expTotal'(val) {
        if (val >= 10 && !this.miniQuestData[1].acquired) {
          this.finishMiniQuest(1)
        }
      },
      'userDataStore.performancePoint'(val) {
        if (val >= 10 && !this.badgesData[3].acquired) {
          this.acquireBadge(3)
        }
        if (val >= 25 && !this.badgesData[4].acquired) {
          this.acquireBadge(4)
        }
        if (val >= 50 && !this.badgesData[5].acquired) {
          this.acquireBadge(5)
        }
      },
      'userDataStore.finishedTask.length'(val) {
        if (val === 0) return

        if (this.userDataStore.finishedTask.filter((item) => item.lessonsId).length >= 5 && !this.badgesData[6].acquired) {
          this.acquireBadge(6)
        }
        if (!this.badgesData[7].acquired && this.userDataStore.finishedTask[this.userDataStore.finishedTask.length-1].lessonsId === 7) {
          this.acquireBadge(7)
        }
        if (val !== 0 && !this.miniQuestData[0].acquired) {
          this.finishMiniQuest(0)
        }
        if (this.userDataStore.finishedTask.filter((item) => item.questId).length > 0 && !this.miniQuestData[2].acquired) {
          this.finishMiniQuest(2)
        }
      },
      badgeQueue() {
        this.showBadges()
      }
    },
    computed: {
      userDataStore() {
        return this.$store.state.userStore
      },
      badgesData() {
        return this.$store.state.userStore.badges
      },
      miniQuestData() {
        return this.$store.state.userStore.miniQuests
      },
      hasNotLogin() {
        return this.$store.getters['userStore/hasNotLogin']
      },
    },
    methods: {
      acquireBadge(index) {
        this.badgesData[index].acquired = true
        this.badgesData[index].acquiredDate = new Date()
        this.badgesData[index].type = 'badge'
        this.$store.commit('userStore/addZenny', {value: this.badgesData[index].reward})
        this.badgeQueue.push(this.badgesData[index])
      },
      finishMiniQuest(index) {
        this.miniQuestData[index].acquired = true
        this.miniQuestData[index].type = 'miniQuest'
        this.$store.commit('userStore/addZenny', {value: this.miniQuestData[index].reward})
        this.badgeQueue.push(this.miniQuestData[index])
      },
      showBadges() {
        if (this.isAppear) return

        this.currentItem = this.badgeQueue.pop()
        this.isAppear = true
        this.timeoutObj = setTimeout(() => {
          this.isAppear = false
          if (this.badgeQueue.length > 0) {
            this.$nextTick(() => this.showBadges())
          }
        }, 5000)
      },
      skipBadge() {
        if (!this.isAppear) return

        clearTimeout(this.timeoutObj)
        this.isAppear = false
        if (this.badgeQueue.length > 0) {
          this.$nextTick(() => this.showBadges())
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .badge-catcher {
    position: fixed;
    top: 1rem;
    left: 1rem;
    display: flex;
    padding: 1rem;
    z-index: 1000;
    cursor: pointer;
    animation: flash 1s ease;
  }

  .image-wrapper {
    width: 64px;
    height: 64px;
  }
</style>
